import { Box, InputAdornment, TextField, Typography } from "@mui/material";
import React, { MouseEventHandler, useEffect, useState } from "react";
import { ArrowDropDown, ArrowDropUp, Padding } from "@mui/icons-material";
import style from "./style.module.scss";
import { ExpandDownIcon, ExpandUpIcon, MinusSignIcon, PlusSignIcon } from "../../assets/icons";

interface InputNumberProps {
  value?: number;
  onChange: (limit: number) => void;
}

export default function InputRange(props: InputNumberProps) {
  const increment = () => {
    props.onChange(Number(props.value) + 1);
  };
  const decrement = () => {
    props.onChange(Number(props.value) === 0 ? 0 : Number(props.value) - 1);
  };

  const handleChange = (event: any) => {
    const value = event.target.value;
    const test = value.match(/[0-9]*/);
    if (test[0] !== "" || value.length === 0) {
      props.onChange(Number(test[0]));
    }
  };

  return (
    <TextField
      sx={{
        width: "100%",
        "& > .MuiInputBase-root": { margin: 0, padding: 0, height: "50px", borderRadius: "8px" },
        "& .MuiInputAdornment-positionStart": {
          padding: "12px 6px",
          borderTopLeftRadius: "5px",
          borderBottomLeftRadius: "5px",
          margin: 0,
        },
        "& .MuiInputAdornment-positionEnd": {
          margin: 0,
          padding: "12px 6px",
        },
        "& .MuiOutlinedInput-input": {
          height: "24px",
          // width: "22px",
          padding: 0,
          color: "text.dark",
          textAlign: "center",
          fontSize: "14px",
          fontStyle: "normal",
          fontWeight: 600,
          lineHeight: "normal",
        },
        "& .MuiOutlinedInput-notchedOutline": {
          borderColor: "#e5e7ea !important",
        },
      }}
      className={style.input_number}
      value={props.value}
      onChange={handleChange}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <MinusSignIcon className={style.arrow_down} onClick={decrement} />
          </InputAdornment>
        ),
        endAdornment: (
          <InputAdornment position="end">
            <PlusSignIcon className={style.arrow_up} onClick={increment} />
          </InputAdornment>
        ),
      }}
    />
  );
}
